const cok = document.cookie
  .split(";")
  .filter((cookie: string) => cookie.trim().split("=")!.includes("token"));
const errorMessage = document.cookie
  .split(";")
  .filter((cookie: string) =>
    cookie.trim().split("=")!.includes("errorMessage")
  );

export let GCPENDPOINT: string = "";

declare global {
  interface Window { env: any; }
}

export const setEnv = () => {
  if (window.env) {
    GCPENDPOINT = `https://storage.googleapis.com/${window.env.CLOUD_STORAGE_BUCKET_NAME}/`
  }
}
export const getCookie = cok.length > 0 ? cok[0].split("=")[1] : false;
export const getErrorMessage =
  errorMessage.length > 0 ? errorMessage[0].split("=")[1] : false;

export const APIURL =
  !process.env.NODE_ENV || process.env.NODE_ENV === "development"
    ? "http://localhost:3030/api/v1/"
    : window.location.origin + "/api/v1/";

export const IframeURL =
  !process.env.NODE_ENV || process.env.NODE_ENV === "development"
    ? "http://localhost:3002"
    : `${window.location.origin}/form-renderer/`;

export const IframeTargetOrigin = "*";

export const MARKETPLACE_CORE = !process.env.NODE_ENV || process.env.NODE_ENV === "development"
  ? "https://studio-testing.autonom8.com/marketplace/core" //Replace with http://localhost:3003 for local testing
  : `${window.location.origin}/marketplace/core`;

export const MARKETPLACE_CORE_V2 = !process.env.NODE_ENV || process.env.NODE_ENV === "development"
  ? "http://localhost:3003" //Replace with http://localhost:3003 for local testing
  : `${window.location.origin}/marketplace/core-v2`;

export const MARKETPLACE_CORE_V3 = !process.env.NODE_ENV || process.env.NODE_ENV === "development"
  ? "http://localhost:3004" //Replace with http://localhost:3004 for local testing
  : `${window.location.origin}/marketplace/core-v3`;

export const MQTT_URL =
  !process.env.NODE_ENV || process.env.NODE_ENV === "development"
    ? "wss://studio-testing.autonom8.com/mqtt"
    : window.location.origin.replace("https:", "wss:") + "/mqtt";
